import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sendTaxCertState, sendTaxCertFeatureKey } from '../reducers/send-tax-cert.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as sendTaxState from '../reducers/send-tax-cert.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, sendTaxCertState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee send Tax cert SUB STATE
export const getSendTaxState = createSelector(getMainEmployeeState, state => state[sendTaxCertFeatureKey]);
//#endregion

//#region Employee send Tax cert SUB STATE
export const getSendTaxRequest = createSelector(getSendTaxState, sendTaxState.sendTaxRequest);
export const getSendTaxSuccess = createSelector(getSendTaxState, sendTaxState.sendTaxResponse);
export const getSendTaxFailure = createSelector(getSendTaxState, sendTaxState.sendTaxFailure);
//#endregionrx/store';
